import { ButtonProps, Button } from "@brandclub/common-ui";
import { styled } from "@mui/material";
import React from "react";

const StyledButton = styled(Button, {
  label: "ShopAppButton",
})({
  "&&": {
    minWidth: "fit-content",
  },
});

export const ShopAppButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { sx, ...rest } = props;
    return (
      <StyledButton
        ref={ref}
        {...rest}
        increaseSpecificity
        sx={(theme) => ({
          "&&": { ...(typeof sx === "function" ? sx(theme) : sx) },
        })}
      />
    );
  }
);
